import script from "./discountCoupon.vue?vue&type=script&setup=true&lang=js"
export * from "./discountCoupon.vue?vue&type=script&setup=true&lang=js"

import "./discountCoupon.vue?vue&type=style&index=0&id=0de82ca3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0de82ca3"]])

export default __exports__